import { Component, ElementRef, ViewChild } from '@angular/core';
import { ConsentFormService } from '../../services/consentForm.service';
import { ConsentForm } from '../../model/consentForm.model';
import { ActivatedRoute } from '@angular/router';
import { EncryptionService } from '../../services/encryption.service';
import { ChangeDetectorRef } from '@angular/core';
import SignaturePad from 'signature_pad';
import { Subscription } from 'rxjs';
import Swal from 'sweetalert2';
import { NgZone } from '@angular/core';
import { SelectItem } from 'primeng/api';
import { SelectedItemService } from "../../services/selectItem.service";
import { DatePipe, registerLocaleData } from '@angular/common';
import localeZhHant from '@angular/common/locales/zh-Hant';
import { NgForm } from '@angular/forms';
import { ReCaptchaV3Service } from 'ng-recaptcha';

registerLocaleData(localeZhHant, 'zh-Hant');

@Component({
  selector: 'app-consentFormOnline',
  templateUrl: './consentFormOnline.component.html',
  styleUrls: ['./consentFormOnline.component.scss']
})
export class ConsentFormOnlineComponent {
    @ViewChild('canvas') canvas!: ElementRef<HTMLCanvasElement>;
    signaturePad!: SignaturePad;
    /** 同意書Scroll */
    @ViewChild('consentFormScrollPanel') public scrollPanel: any;
    @ViewChild('form') form!: NgForm;
    loading = false;
    model: ConsentForm = new ConsentForm();
    CompanyName: string = "";
    Address: string = "";
    Telephone: string = "";
    viewType: number = 0;
    /**類型(0:美容,1:住宿) */
    //Type: string = "";
    Title: string = "";
    origVarityList: any;
    VarityList: SelectItem[] | null = null;
    /** 同意書內容 */
    public consentFormContent: string = "";
    /** 是否已閱讀完同意書(滾動至最底) */
    public isConsentFormRead: boolean = false;
    isScrollBottom = false;
    isAgreed = false;
    subscribes: Subscription = new Subscription();
    constructor(
      private encryptionService: EncryptionService,
      private route: ActivatedRoute,
      private formService: ConsentFormService,
      private recaptchaV3Service: ReCaptchaV3Service,
      private SelectedItemService:SelectedItemService,
      private zone:NgZone
    ) {}

    ngOnInit() {
      var that = this; 
      this.model = new ConsentForm();
      //從querystring取得門市資訊
      this.route.queryParams.subscribe((value) => {
        if (!!value["code"]) {
          // const param = {CompanyID: "1121120006", StoreNo: "122112000009",Type: "0"};
          // const end = this.encryptionService.encode(JSON.stringify(param));
          // console.log("end",end);
          //eyJDb21wYW55SUQiOiIxMTIxMTIwMDA2IiwiU3RvcmVObyI6IjEyMjExMjAwMDAwOSIsIlR5cGUiOiIwIn0=   美容
          //eyJDb21wYW55SUQiOiIxMTIxMTIwMDA2IiwiU3RvcmVObyI6IjEyMjExMjAwMDAwOSIsIlR5cGUiOiIxIn0=   住宿
          var code = this.encryptionService.decode(value["code"]);
          var codeM = JSON.parse(code);
          
          localStorage.setItem("CompanyID", codeM["CompanyID"]);
          localStorage.setItem("StoreNo", codeM["StoreNo"]);
          localStorage.setItem("Type", codeM["Type"]);
        } else if (!!value["CompanyID"] && !!value["StoreNo"]) {
          
          localStorage.setItem("CompanyID", value["CompanyID"]);
          localStorage.setItem("StoreNo", value["StoreNo"]);
          localStorage.setItem("Type", codeM["Type"]);
        }
        this.model.CompanyID = codeM["CompanyID"];
        this.model.StoreNo = codeM["StoreNo"];
        this.model.Type = codeM["Type"];
      });
      
      this.GetCompany();
    }

    ngAfterViewInit() {
      this.resizeCanvas();
      // 初始化簽名板
      this.signaturePad = new SignaturePad(this.canvas.nativeElement, {
        backgroundColor: '#ffffff',
        minWidth: 1,
        maxWidth: 3
      });

      // 簽名完成事件
      this.signaturePad.addEventListener('endStroke', () => {
        this.zone.run(() => {
          this.model.SignaturePath = this.signaturePad.toDataURL('image/png');
        });
      });
      // 防止手機滑動 / 選取
      const canvasEl = this.canvas.nativeElement;

      canvasEl.addEventListener('touchstart', (e) => e.preventDefault());
      canvasEl.addEventListener('touchmove', (e) => e.preventDefault());
      // 手機旋轉 / resize 時也要重算
      window.addEventListener('resize', () => {
        this.resizeCanvas();
      });

      // scroll 事件
      setTimeout(() => {
        const el = this.scrollPanel?.contentViewChild?.nativeElement;
        if (!el) return;

        el.addEventListener('scroll', () => {
          const isBottom = el.scrollHeight - el.scrollTop - el.clientHeight <= 1;
          this.zone.run(() => {
            this.isScrollBottom = isBottom;
            if (isBottom) this.isConsentFormRead = true;
          });
        });
      });
    }

    resizeCanvas() {
      const canvas = this.canvas.nativeElement;
      const rect = canvas.getBoundingClientRect();
      const ratio = window.devicePixelRatio || 1;

      canvas.width = rect.width * ratio;
      canvas.height = rect.height * ratio;

      canvas.getContext('2d')!.scale(ratio, ratio);

      if (this.signaturePad) {
        this.signaturePad.clear();
      }
    }

    ngOnDestroy() {
      this.subscribes.unsubscribe();
    }

    GetCompany(){
        var data = this.formService.GetCompany(this.model.CompanyID,this.model.StoreNo,this.model.Type).subscribe((result: any)=>{
            this.GetCompanySuceed(result);
        });
        this.subscribes.add(data);
    }

    submitForm(form: any){
        this.save();
        if (form.invalid) return;

        this.loading = true;
         // 先取得 token
        this.recaptchaV3Service.execute('submit').subscribe((token: string) => {
          this.verifyRecaptcha(token);
        });
    }
    verifyRecaptcha(recaptchaToken: string){
      this.formService.verifyRecaptcha(recaptchaToken).subscribe((result: any)=>{
          if (result && result.ErrorFlag === "1") {
                Swal.fire('失敗', result.ErrorMsg || '操作失敗', 'error');
                return;
          }else{console.log("正確");
              this.formService.submitForm(this.model).subscribe({
                next: (res: any) => {
                  if (res && res.ErrorFlag === "1") {
                    Swal.fire('失敗', res.ErrorMsg || '操作失敗', 'error');
                    return;
                  }
                  Swal.fire('完成', '資料已成功送出！', 'success');
                  this.viewType = 1;
                },
                error: () => {
                  Swal.fire('失敗', '資料送出失敗！', 'error');
                },
                complete: () => {
                  this.loading = false;
                }
              });
          }
      });

    }

    resetForm() {
      var companyID = this.model.CompanyID;
      var storeNo = this.model.StoreNo;

      this.model = new ConsentForm();
      this.model.CompanyID = companyID;
      this.model.StoreNo = storeNo;
      const now = new Date();
      const datePipe = new DatePipe('zh-Hant'); // 建立 DatePipe 實例
      this.model.SignatureTime = datePipe.transform(now, 'yyyy-MM-dd') || '';

      this.isAgreed = false;
      this.isConsentFormRead = false;
      this.isScrollBottom = false;
      this.form?.resetForm();

      setTimeout(() => { // 確保 canvas 已經渲染
        if (this.canvas) {
          this.signaturePad = new SignaturePad(this.canvas.nativeElement);
          this.signaturePad.clear();
        }
      }, 0);
    }

    GetCompanySuceed(result: any){
        if(result.ErrorFlag == '1'){
            Swal.fire({
              icon: 'error',
              title: '發生錯誤',
              text: '請稍後再試'
            });
            return;
        }
        this.CompanyName = result.CompanyName;
        this.Address = result.Address;
        this.Telephone = result.Telephone;
        this.Title = (this.model.Type == "0")? "寵物美容定型化契約": "寵物住宿定型化契約";
        this.origVarityList = result.varity;
        this.VarityList = this.SelectedItemService.convertToSelectItem(this.origVarityList,"ChNo","ChName");
        const now = new Date();
        const datePipe = new DatePipe('zh-Hant'); // 建立 DatePipe 實例
        this.model.SignatureTime = datePipe.transform(now, 'yyyy-MM-dd') || '';
        
        this.consentFormContent = result.content;
        this.isConsentFormRead = false;
        this.isScrollBottom = false;
    }
    /**清除簽名 */
    clear() {
      this.signaturePad.clear();
      this.model.SignaturePath = '';
    }

    save() {
      if (this.signaturePad.isEmpty()) {
        Swal.fire('失敗', '請先簽名!', 'warning');
        return;
      }

      const signatureBase64 = this.signaturePad.toDataURL('image/png');

      this.model.SignaturePath = signatureBase64;
    }
    
    goBack(){ 
      this.viewType = 0;
      this.clear();
      this.resetForm();
    }

    get isSigned() {
      return this.signaturePad && !this.signaturePad.isEmpty();
    }
}
